module.exports = __webpack_public_path__ + "static/media/map1.06da7ae6.png";